import React from 'react';

/**
 * La mise en page commune aux étapes du parcours : un titre, une explication, un contenu.
 *
 * Tenue à part pour que les cinq étapes ne recopient pas les mêmes marges — c'est ce qui fait
 * qu'un parcours paraît d'une seule pièce plutôt qu'une suite d'écrans assemblés.
 */
function CadreEtape({ titre, explication, erreur, children, largeur = '460px' }) {
  return (
    <div style={{ width: '100%', maxWidth: largeur }}>
      <h3 style={{
        margin: '0 0 10px', fontSize: '22px', fontWeight: 600,
        color: '#1f2937', textAlign: 'center'
      }}>
        {titre}
      </h3>
      {explication && (
        <p style={{
          margin: '0 0 24px', color: '#6b7280', fontSize: '15px',
          lineHeight: 1.6, textAlign: 'center'
        }}>
          {explication}
        </p>
      )}

      {children}

      {erreur && (
        <div style={{
          marginTop: '16px', padding: '12px 14px', borderRadius: '8px',
          background: '#fef2f2', border: '1px solid #fecaca',
          fontSize: '13px', color: '#b91c1c'
        }}>
          {erreur}
        </div>
      )}
    </div>
  );
}

export const champ = {
  width: '100%', boxSizing: 'border-box', padding: '11px 13px',
  border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '15px'
};

export const etiquette = {
  display: 'block', fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '6px'
};

export default CadreEtape;
